import React from 'react';
import loc from 'sources/locale/loc';
import SiteNavBarLink from './SiteNavBarLink';

function AdminButtons() {
  return (
    <>
      <SiteNavBarLink label={loc('users')} path="/admin/users" />
    </>
  );
}

export default AdminButtons;



// WEBPACK FOOTER //
// ./src/components/SiteNavBar/AdminButtons.jsx